module.exports = __webpack_public_path__ + "img/box3_img3_active.ef64b167.png";